module.exports = __webpack_public_path__ + "img/colored-paper-10.14b2f983.png";